module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-studio-94f2888a845fc1077c084455735acc21.jpg";